/* ShipsTrading Custom UI for Avone Theme - V7.0 (Deadweight Top Sort Edition) */
document.addEventListener('DOMContentLoaded', function() {
  if (!document.body.classList.contains('template-product')) return;
  const container = document.querySelector('.product-single__description.rte');
  if (!container) return;
  const clone = container.cloneNode(true);
  const brTags = clone.querySelectorAll('br');
  brTags.forEach(br => br.replaceWith('\n'));
  const fullTextWithNewlines = clone.textContent.trim();
  const lines = fullTextWithNewlines.split('\n');
  const data = {
    summary: { title: 'Strategic Insight', text: [] },
    status: { title: 'SHIP SPECIFICATIONS', items: [] },
    dimensions: { title: 'Dimensions & Capacity', items: [] },
    propulsion: { title: 'Propulsion & Engineering', items: [] },
    insight: { title: 'Expert Acquisition Insight', text: [] }
  };
  const keys = {
    status: ['class', 'classification', 'navigation', 'built', 'dock', 'port', 'registry', 'date', 'survey', 'number', 'type', 'crews', 'flag'],
    dimensions: ['length', 'breadth', 'depth', 'draft', 'grt', 'nrt', 'dwt', 'deadweight', 'tonnage', 'displacement', 'capacity', 'overall', 'teu', 'payload', 'cargo', 'hold', 'crane'],
    propulsion: ['engine', 'speed', 'generator', 'consumption', 'oil', 'propulsion', 'knots', 'fuel']
  };
  let specIndices = [];
  lines.forEach((line, index) => {
    if (line.trim().match(/(:|：)/)) specIndices.push(index);
  });
  if (specIndices.length > 0) {
    const firstIndex = specIndices[0];
    const lastIndex = specIndices[specIndices.length - 1];

    let currentCategory = null;
    let currentItemIndex = -1;
    lines.forEach((line, index) => {
      let trimmedLine = line.trim();
      if (!trimmedLine) return;
      const cleanLine = trimmedLine.replace(/^[•\-\*·]\s*/, '').trim();
      const match = cleanLine.match(/^(.*?)(:|：)\s*(.*)$/);
      if (match) {
        let label = match[1].trim();
        const value = match[3].trim();
        const labelLower = label.toLowerCase();

        let matchedCategory = 'status';
        if (keys.status.some(k => labelLower.includes(k))) matchedCategory = 'status';
        if (keys.dimensions.some(k => labelLower.includes(k))) matchedCategory = 'dimensions';
        if (keys.propulsion.some(k => labelLower.includes(k))) matchedCategory = 'propulsion';

        if (labelLower.includes('cargo hold')) matchedCategory = 'dimensions';
        if (labelLower.includes('oil consumption') || labelLower.includes('oil')) {
          label = 'Fuel Consumption';
          matchedCategory = 'propulsion';
        }
        data[matchedCategory].items.push({ label: label, value: value });
        currentCategory = matchedCategory;
        currentItemIndex = data[matchedCategory].items.length - 1;
      } else {
        const cleanLineLower = cleanLine.toLowerCase();

        if (cleanLineLower.includes('kw') || cleanLineLower.includes('rpm')) {
          if (data.propulsion.items.length > 0) {
            let lastPropIndex = data.propulsion.items.length - 1;
            let existingValue = data.propulsion.items[lastPropIndex].value;
            data.propulsion.items[lastPropIndex].value = existingValue ?
              (existingValue + '<br><span style="font-weight:normal; font-size:13px;">' + cleanLine + '</span>') : cleanLine;
          } else {
            data.propulsion.items.push({ label: 'Engine / Generator', value: cleanLine });
          }
        }
        else if (index < firstIndex) {
          data.summary.text.push(trimmedLine);
        } else if (index > lastIndex) {
          data.insight.text.push(trimmedLine);
        } else {
          if (currentCategory && currentItemIndex >= 0) {
            let existingValue = data[currentCategory].items[currentItemIndex].value;
            data[currentCategory].items[currentItemIndex].value = existingValue ?
              (existingValue + '<br><span style="font-weight:normal; font-size:13px;">' + cleanLine + '</span>') : cleanLine;
          }
        }
      }
    });
  } else {
    lines.forEach(line => { if (line.trim()) data.summary.text.push(line.trim()); });
  }
  // 重排 SHIP SPECIFICATIONS
  let newStatusItems = [];
  let numberItem = null;
  let typeItem = null;
  let otherStatusItems = [];
  data.status.items.forEach(item => {
    let lbl = item.label.toLowerCase();
    if (lbl === 'number' || lbl === 'number.') {
      numberItem = item;
    } else if (lbl.includes('type of ship') || lbl.includes('ship type')) {
      typeItem = item;
    } else {
      otherStatusItems.push(item);
    }
  });
  if (numberItem) newStatusItems.push(numberItem);
  if (typeItem) newStatusItems.push(typeItem);
  newStatusItems = newStatusItems.concat(otherStatusItems);
  data.status.items = newStatusItems;
  // 核心新增：重排 Dimensions & Capacity，强制让 Deadweight 排在第一行
  let newDimItems = [];
  let dwtItems = [];
  let otherDimItems = [];
  data.dimensions.items.forEach(item => {
    let lbl = item.label.toLowerCase();
    if (lbl.includes('deadweight') || lbl.includes('dwt')) {
      dwtItems.push(item);
    } else {
      otherDimItems.push(item);
    }
  });
  // 将 Deadweight 放在最前面，剩下的跟在后面
  newDimItems = dwtItems.concat(otherDimItems);
  data.dimensions.items = newDimItems;
  // 重排 Propulsion & Engineering
  let newPropItems = [];
  let engineItems = [];
  let generatorItems = [];
  let otherPropItems = [];
  data.propulsion.items.forEach(item => {
    let lbl = item.label.toLowerCase();
    if (lbl.includes('engine')) {
      engineItems.push(item);
    } else if (lbl.includes('generator')) {
      generatorItems.push(item);
    } else {
      otherPropItems.push(item);
    }
  });
  newPropItems = newPropItems.concat(engineItems, generatorItems, otherPropItems);
  data.propulsion.items = newPropItems;
  // --- HTML 构建逻辑 ---
  let newHTML = '<div class="st-new-layout-container">';
  if (data.summary.text.length > 0) {
    newHTML += `<section class="st-insight-footer" style="margin-bottom: 20px;"><div class="st-insight-inner"><h4 style="margin-top:0; color:#FF6B00; font-size: 15px; text-transform: uppercase;"> 🔍  ${data.summary.title}</h4>`;
    data.summary.text.forEach(text => { newHTML += `<p style="margin-bottom: 8px;">${text}</p>`; });
    newHTML += `</div></section>`;
  }
  function buildModule(moduleData) {
    if (moduleData.items.length === 0) return '';
    let html = `<section class="st-module-card"><h4 class="st-module-header">${moduleData.title}</h4><div class="st-module-body">`;
    moduleData.items.forEach(item => {
      html += `<div class="st-param-row"><span class="st-param-label">${item.label}</span><span class="st-param-value">${item.value}</span></div>`;
    });
    html += `</div></section>`;
    return html;
  }
  newHTML += buildModule(data.status);
  newHTML += buildModule(data.dimensions);
  newHTML += buildModule(data.propulsion);
  if (data.insight.text.length > 0) {
    newHTML += `<section class="st-insight-footer" style="margin-top: 20px; background: #fff; border-top: 1px solid #e5e7eb; border-bottom: none;"><div class="st-insight-inner" style="border-left: 6px solid #FF6B00; padding-left: 15px;"><h4 style="margin-top:0; color:#FF6B00; font-size: 15px; text-transform: uppercase;"> 🛡️  ${data.insight.title}</h4>`;
    data.insight.text.forEach(text => { newHTML += `<p style="margin-bottom: 8px;">${text}</p>`; });
    newHTML += `</div></section>`;
  }
  newHTML += '</div>';
  container.innerHTML = newHTML;
});

/* ShipsTrading: Lead Gate & PDF Generator (Strict V14.0 Base + Anti-Blank Preloading) */
document.addEventListener('DOMContentLoaded', function() {
  const triggerBtn = document.getElementById('st-trigger-pdf-btn');
  const directBtn = document.getElementById('st-direct-download-btn');
  const modal = document.getElementById('st-pdf-modal');
  const closeBtn = document.querySelector('.st-modal-close');
  const form = document.getElementById('st-pdf-lead-form');
  if (triggerBtn && modal && form) {
    //  🚀  核心修改 1：点击时先检查有没有“免密钢印”
    triggerBtn.addEventListener('click', function() {
      if (localStorage.getItem('shipstrading_is_verified_lead') === 'true') {
        const originalText = this.innerHTML;
        this.innerText = 'Generating PDF... Please wait';
        this.disabled = true;
        generateVesselPDF(this, originalText);
      } else {
        modal.style.display = 'flex';
      }
    });
    if (closeBtn) closeBtn.addEventListener('click', () => modal.style.display = 'none');
    window.addEventListener('click', (e) => { if (e.target === modal) modal.style.display = 'none'; });
    const tabBtns = document.querySelectorAll('.st-tab-btn');
    const tabContents = document.querySelectorAll('.st-tab-content');
    tabBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        tabBtns.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.style.display = 'none');
        this.classList.add('active');
        document.getElementById(this.dataset.target).style.display = 'block';
      });
    });
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitBtn = document.getElementById('st-submit-download-btn');
      const originalText = submitBtn.innerHTML;
      submitBtn.innerText = 'Generating PDF... Please wait';
      submitBtn.disabled = true;
      const formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      })
      .then(response => {
        //  🚀  核心修改 2：提交成功后，在浏览器打上“免密钢印”，以后全站互通！
        localStorage.setItem('shipstrading_is_verified_lead', 'true');
        generateVesselPDF(submitBtn, originalText);
        form.reset();
      })
      .catch(error => {
        alert('Something went wrong. Please try again.');
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
      });
    });
  }
  if (directBtn) {
    directBtn.addEventListener('click', function() {
      const originalText = directBtn.innerHTML;
      directBtn.innerText = 'Generating PDF... Please wait';
      directBtn.disabled = true;
      generateVesselPDF(directBtn, originalText);
    });
  }
  function generateVesselPDF(btnElement, originalText) {
    // ---  ⬇️  新增的 5 次限额安检逻辑  ⬇️  ---
    const MAX_DAILY_DOWNLOADS = 5;
    const today = new Date().toDateString();
    let dlData = JSON.parse(localStorage.getItem('shipstrading_pdf_limits') || '{}');
    if (dlData.date !== today) {
      dlData = { date: today, count: 0 };
    }
    if (dlData.count >= MAX_DAILY_DOWNLOADS) {
      alert(" 🔒  NOTICE: You have reached your daily limit of 5 PDF downloads. \n\nPlease come back tomorrow to download more specifications, or contact our broker team (sales@shipstrading.com) for immediate VIP assistance.");
      // 恢复按钮状态
      if(btnElement){
        btnElement.innerHTML = originalText;
        btnElement.disabled = false;
      }
      // 如果是注册弹窗触发的，顺便关掉弹窗
      const modal = document.getElementById('st-pdf-modal');
      if(modal) modal.style.display = 'none';
      return; //  🛑  触碰限额，直接终止后续 of PDF 生成！
    }
    // 额度有效，次数 +1 并保存
    dlData.count++;
    localStorage.setItem('shipstrading_pdf_limits', JSON.stringify(dlData));
    let remaining = MAX_DAILY_DOWNLOADS - dlData.count;
    alert(" ✅  Preparing your PDF... \n\nYou have " + remaining + " downloads left today.");
    // ---  ⬆️  限额逻辑结束  ⬆️  ---
    const printContainer = document.createElement('div');
    printContainer.style.padding = '15px 30px';
    printContainer.style.fontFamily = 'Helvetica, Arial, sans-serif';
    printContainer.style.color = '#333';
    // 1. 顶部首页高清 Logo (保持 V14)
    const topLogo = document.createElement('img');
    topLogo.src = 'https://cdn.shopify.com/s/files/1/0655/1214/4947/files/2026-05-16_21.59.19.jpg?v=1778940126';
    topLogo.crossOrigin = 'anonymous';
    topLogo.style.display = 'block';
    topLogo.style.margin = '0 auto 15px auto';
    topLogo.style.maxHeight = '65px';
    topLogo.style.objectFit = 'contain';
    printContainer.appendChild(topLogo);
    // 2. 标题居中排版 (保持 V14 大留白 45px)
    const pageTitle = document.querySelector('h1.product-single__title');
    const pdfTitle = document.createElement('h1');
    pdfTitle.innerText = pageTitle ? pageTitle.innerText : 'Ship Specifications';
    pdfTitle.style.color = '#1e3a8a';
    pdfTitle.style.fontSize = '20px';
    pdfTitle.style.textAlign = 'center';
    pdfTitle.style.borderBottom = '2px solid #FF6B00';
    pdfTitle.style.paddingBottom = '10px';
    pdfTitle.style.marginBottom = '45px';
    printContainer.appendChild(pdfTitle);
    const imageSource = document.getElementById('st-pdf-images-data');
    let remainingImages = [];
    if (imageSource) {
      const images = imageSource.querySelectorAll('img');
      if (images.length > 0) {
        // 3. 首页主图排版 (保持 V14 大气限高 450px)
        const mainImgWrap = document.createElement('div');
        mainImgWrap.style.textAlign = 'center';
        mainImgWrap.style.marginBottom = '35px';
        mainImgWrap.style.pageBreakInside = 'avoid';

        const firstImgCloned = images[0].cloneNode(true);
        firstImgCloned.style.maxWidth = '100%';
        firstImgCloned.style.width = 'auto';
        firstImgCloned.style.height = 'auto';
        firstImgCloned.style.maxHeight = '450px';
        firstImgCloned.style.borderRadius = '6px';
        firstImgCloned.style.objectFit = 'contain';

        mainImgWrap.appendChild(firstImgCloned);
        printContainer.appendChild(mainImgWrap);

        for (let i = 1; i < images.length; i++) {
          remainingImages.push(images[i]);
        }
      }
    }
    // 4. 公司 Broker 联系方式 (保持 V14 横向舒展三列设计与颜色)
    const contactDiv = document.createElement('div');
    contactDiv.style.background = '#fdf7f2';
    contactDiv.style.borderLeft = '5px solid #FF6B00';
    contactDiv.style.padding = '25px 25px';
    contactDiv.style.marginBottom = '30px';
    contactDiv.style.borderRadius = '4px';
    contactDiv.style.pageBreakInside = 'avoid';
    contactDiv.innerHTML = `
      <h4 style="margin: 0 0 20px 0; color: #1e3a8a; font-size: 16px; text-transform: uppercase; text-align: center;">
        Contact Our Brokers for <span style="color: #FF6600; font-weight: bold;">QUOTATION & INSPECTION</span>
      </h4>
      <div style="font-size: 14px; color: #333; line-height: 1.8; display: flex; justify-content: space-around; align-items: start; border-top: 1px solid #eee; padding-top: 20px;">
        <div style="text-align: center;">
          <strong style="display: block; margin-bottom: 5px;">Simon</strong>
          WhatsApp: +86 175 1286 8928
        </div>
        <div style="text-align: center;">
          <strong style="display: block; margin-bottom: 5px;">Celina</strong>
          WhatsApp: +86 183 5952 6423
        </div>
        <div style="text-align: center;">
          <strong style="display: block; margin-bottom: 5px;">Official Email</strong>
          info@shipstrading.com
        </div>
      </div>
    `;
    printContainer.appendChild(contactDiv);
    // 5. 插入产品参数表格卡片 (保持 V14)
    const specsLayout = document.querySelector('.st-new-layout-container');
    if (specsLayout) {
      const clonedSpecs = specsLayout.cloneNode(true);
      clonedSpecs.style.width = '100%';
      clonedSpecs.style.maxWidth = '100%';
      clonedSpecs.style.marginLeft = '0';
      clonedSpecs.style.marginBottom = '30px';
      const cards = clonedSpecs.querySelectorAll('.st-module-card, .st-insight-footer');
      cards.forEach(card => {
        card.style.pageBreakInside = 'avoid';
        card.style.breakInside = 'avoid';
      });
      printContainer.appendChild(clonedSpecs);
    }
    // 6. 剩余所有图片排版 (严格保持 V14 的单行一张 100% 铺满自适应)
    if (remainingImages.length > 0) {
      const extraImageContainer = document.createElement('div');
      extraImageContainer.style.textAlign = 'center';
      extraImageContainer.style.marginTop = '20px';
      remainingImages.forEach(img => {
        const imgWrap = document.createElement('div');
        imgWrap.style.display = 'block';
        imgWrap.style.width = '100%';
        imgWrap.style.marginBottom = '25px';
        imgWrap.style.pageBreakInside = 'avoid';

        const clonedImg = img.cloneNode(true);
        clonedImg.style.maxWidth = '100%';
        clonedImg.style.width = 'auto';
        clonedImg.style.height = 'auto';
        clonedImg.style.maxHeight = '420px';
        clonedImg.style.borderRadius = '4px';
        clonedImg.style.objectFit = 'contain';

        imgWrap.appendChild(clonedImg);
        extraImageContainer.appendChild(imgWrap);
      });
      printContainer.appendChild(extraImageContainer);
    }
    // =========================================================
    // 【新增优化逻辑】：强制预加载监控，解决因网速波动导致的下载空白问题
    // =========================================================

    // 1. 监控和等待打印容器里的所有船舶图片
    const allImages = Array.from(printContainer.querySelectorAll('img'));
    const imagePromises = allImages.map(img => {
      return new Promise(resolve => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve; // 防止坏图挂掉导致死锁
        }
      });
    });
    // 2. 监控和预加载右下角水印 Logo
    const logoImg = new Image();
    logoImg.crossOrigin = 'anonymous';
    logoImg.src = 'https://cdn.shopify.com/s/files/1/0655/1214/4947/files/IMG_0911.jpg?v=1778933905';
    const logoPromise = new Promise(resolve => {
      logoImg.onload = () => resolve(logoImg);
      logoImg.onerror = () => resolve(null);
    });
    // 3. 核心机制：所有图片资源全部在内存中下载完毕后，发令枪打响，再调用 PDF 渲染
    Promise.all([...imagePromises, logoPromise]).then(results => {
      const watermark = results[results.length - 1];
      buildPdfAndDownload(watermark);
    });
    function buildPdfAndDownload(watermark) {
      const opt = {
        margin:       [0.5, 0.4, 0.8, 0.4],
        filename:     `${pdfTitle.innerText.replace(/[^a-z0-9]/gi, '_').toLowerCase()}_specs.pdf`,
        image:        { type: 'jpeg', quality: 1.0 },
        html2canvas:  { scale: 3, useCORS: true, letterRendering: true },
        jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' },
        pagebreak:    { mode: ['css', 'legacy'] }
      };

      let worker = html2pdf().set(opt).from(printContainer);
      worker.toPdf().get('pdf').then(function(pdf) {
        if (watermark) {
          const totalPages = pdf.internal.getNumberOfPages();
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const imgWidth = 1.4;
          const imgHeight = (watermark.height / watermark.width) * imgWidth;
          const x = pdfWidth - imgWidth - 0.3;
          const y = pdfHeight - imgHeight - 0.25;
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            try { pdf.setGState(new pdf.GState({opacity: 0.5})); } catch(e) {}
            pdf.addImage(watermark, 'JPEG', x, y, imgWidth, imgHeight);
            try { pdf.setGState(new pdf.GState({opacity: 1.0})); } catch(e) {}
          }
        }
      }).save().then(() => {
        if (btnElement) {
          btnElement.innerHTML = originalText;
          btnElement.disabled = false;
        }
        if (modal) modal.style.display = 'none';
      });
    }
  }
});

//  🚀  【工业级智能防弹版】接收来自 Hub 聚合页的“远程自动下载 PDF”指令
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('auto_pdf') === 'true') {
    // 1. 自动赋予免密下载权限，防止客户在产品页又被弹窗拦截
    localStorage.setItem('shipstrading_is_verified_lead', 'true');

    // 2. 静默清理 URL 尾巴，防止客户刷新页面时重复下载
    window.history.replaceState({}, document.title, window.location.pathname);

    // 3. 核心解耦：对隐藏区域的懒加载大图进行批量强制解码与极速 CDN 压缩优化
    const pdfImages = document.querySelectorAll('#st-pdf-images-data img, .st-pdf-images img');
    const imageLoadPromises = [];

    pdfImages.forEach(img => {
      let realSrc = img.getAttribute('data-src') || img.src;
      if (realSrc) {
        // 标准 Shopify CDN 缩略图优化追加，规避字符串强切导致的 404 碎链隐患
        let optimizedSrc = realSrc.includes('?') 
          ? realSrc.replace('?', '?width=800&') 
          : realSrc + '?width=800';

        img.src = optimizedSrc;
        img.removeAttribute('loading'); // 强行撕掉浏览器的原生懒加载标签

        // 智能状态捕获
        const p = new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = () => resolve();
            img.onerror = () => resolve(); // 哪怕图片本身损坏，也必须通过，防止引擎无限死锁
          }
        });
        imageLoadPromises.push(p);
      }
    });

    // 4. 智能发令枪逻辑：所有图片加载完后即刻下载；若遇极端慢网，3 秒强制兜底吐出 PDF！
    const allImagesDone = Promise.all(imageLoadPromises);
    const maxSafetyTimeout = new Promise((resolve) => setTimeout(resolve, 3000));

    Promise.race([allImagesDone, maxSafetyTimeout]).then(() => {
      const triggerBtn = document.getElementById('st-direct-download-btn');
      if (triggerBtn) {
        triggerBtn.click();
      }
    });
  }
});